import { hot } from 'react-hot-loader/root';
import React from 'react';
import './App.css';
import './Global.css';
import {withAuthentication} from "./firebase/withAuthentication";
import {ConnectedRouter} from "connected-react-router";
import {history} from "./store";
import {AuthUserContext} from "./firebase/AuthUserContext";
import SignInLayout from "./layout/SignInLayout";
import Dashboard from "./layout/Router";

class App extends React.Component {
    public render() {
        return (
            <ConnectedRouter history={history}>
                <AuthUserContext.Consumer>
                    {({authUser}) => (authUser ? <Dashboard/> : <SignInLayout/>
                    )}
                </AuthUserContext.Consumer>
            </ConnectedRouter>
        );
    }
}

export default process.env.NODE_ENV === "development" ? hot(withAuthentication(App)) : withAuthentication(App)
